import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';
import { User } from 'firebase/auth';
import { RouterModule } from '@angular/router';
import { BaseTopAppBarComponent } from '../../shared/ui/base-top-app-bar/base-top-app-bar.component';

/**
 * Top app bar component for the billing page.
 * Extends BaseTopAppBarComponent to inherit user profile and balance display.
 */
@Component({
  selector: 'app-billing-top-app-bar',
  imports: [RouterModule, MatIconModule, MatButtonModule, BaseTopAppBarComponent],
  templateUrl: './billing-top-app-bar.component.html',
  styleUrls: ['./billing-top-app-bar.component.scss'],
})
export class BillingTopAppBarComponent {
  @Input() user$!: Observable<User | null>;
  @Output() signOut = new EventEmitter<void>();
  @Output() switchAccount = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();

  onSignOut(): void {
    this.signOut.emit();
  }

  onSwitchAccount(): void {
    this.switchAccount.emit();
  }

  onRefresh(): void {
    this.refresh.emit();
  }
}
